var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.69 10.662-6.305-6.256C10.14 4.162 9.813 4 9.486 4H5.228C4.573 4 4 4.569 4 5.219v4.225c0 .325.164.65.41.893l6.303 6.257c.246.243.573.406.9.406.328 0 .655-.163.901-.406l4.257-4.225c.491-.406.491-1.219-.082-1.707Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.905 9.125c.694 0 1.256-.56 1.256-1.25s-.562-1.25-1.256-1.25-1.257.56-1.257 1.25.563 1.25 1.257 1.25Z",
    fill: "currentColor"
  })));
};
export default SvgTag;